import React from 'react';
import {SPP_BUILDER_TYPES} from '../../constants/SolutionType';
import {useReviewContext} from '../../../../contexts/ReviewContext';
import {builderFieldsType} from '../builderFields';
import Loading from '../../../../components/Loading/Loading';
import AutoField, {ActionType} from '../../../../components/AutoForm/AutoFieldNew';
import {useAutoForm} from '../../../../components/AutoForm/useAutoForm';

export const BuilderSPPOptions: React.FC<{
  isSubmitting: boolean;
}> = (props) => {
  const {isSubmitting} = props;
  const {values} = useAutoForm<builderFieldsType>();
  const {loadingReview} = useReviewContext();

  if (loadingReview) {
    return <Loading />;
  }

  const options = [
    {
      label: SPP_BUILDER_TYPES.ExecutionOnly,
      value: SPP_BUILDER_TYPES.ExecutionOnly,
    },
    {
      label: SPP_BUILDER_TYPES.Advised,
      value: SPP_BUILDER_TYPES.Advised,
    },
  ];

  return (
    <AutoField
      key={values.sppType}
      field={{
        type: ActionType.radioGroup,
        disabled: isSubmitting,
        boldLabel: true,
        id: 'sppType',
        options,
        label: 'Is this instruction',
      }}
    />
  );
};
